// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2MMXI","col":"styles_col__1BSP6"};